<template>
    <div class="customerManage-container">
        <el-card class="mb16">
            <div class="customerManage-query">
                <div class="customerManage-query-input">
                    <div class="query-input-item">
                        <span class="input-item-label"> 客户ID:</span>
                        <el-input class="query-input" size="small" placeholder="请输入客户ID" v-model="query.traderId" clearable></el-input>
                    </div>
                    <!-- 未定义变量 -->
                    <div class="query-input-item">
                        <span class="input-item-label"> 商户号:</span>
                        <el-input class="query-input" size="small" placeholder="请输入商户号" v-model="query.api_key" clearable></el-input>
                    </div>
                    <div class="query-input-item">
                        <span class="input-item-label"> 昵称:</span>
                        <el-input class="query-input" size="small" placeholder="请输入客户昵称" v-model="query.name" clearable></el-input>
                    </div>
                    <div class="query-input-item">
                        <span class="input-item-label"> 邮箱:</span>
                        <el-input size="small" placeholder="请输入客户邮箱" v-model="query.email" clearable></el-input>
                    </div>
                    
                </div>
                <div class="customerManage-query-input query-input-flex-between">
                    <div class="flexX">
                        <!-- 未定义变量 -->
                        <div class="query-input-item">
                            <span class="input-item-label"> 状态:</span>
                            <el-select v-model="query.status" clearable="" placeholder="请选择状态" size="mini" class="mr20 query-select">
                                <el-option label="启用" value="1"></el-option>
                                <el-option label="禁用" value="0"></el-option>
                            </el-select>
                        </div>
                        
                        <div class="query-input-item">
                            <span class="input-item-label"> CK生效状态:</span>
                            <el-select v-model="query.ck_valid" clearable="" placeholder="请选择状态" size="mini" class="mr20 query-select">
                                <el-option label="启用" value="1"></el-option>
                                <el-option label="禁用" value="0"></el-option>
                            </el-select>
                        </div>
                        
                        <div class="query-input-item">
                            <span class="input-item-label"> CK启用状态:</span>
                            <el-select v-model="query.ck_status" clearable="" placeholder="请选择状态" size="mini" class="mr20 query-select">
                                <el-option label="启用" value="1"></el-option>
                                <el-option label="禁用" value="0"></el-option>
                            </el-select>
                        </div>
                        

                        <!-- 未定义变量 -->
                        <div class="query-input-item">
                            <span class="input-item-label"> 注册时间:</span>
                            <el-date-picker class="query-date" size="medium" v-model="query.create_time" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                        </div>
                    </div>

                    <div class="customerManage-query-btn">
                        <el-button class="query-btn" type="primary" size="small" @click = "getData" :disabled = "loading" icon="el-icon-search">查询</el-button>
                        <el-button class="query-btn cancel" plain size="small" @click="reset" :disabled = "loading" icon="el-icon-refresh">重置</el-button>
                    </div>
                </div>
                
            </div>
        </el-card>  
        <el-card >
            <div class="customerManage-btn-div">            
                <el-button class="add-btn" type="primary" size="small" @click="addCustomer">新增客户</el-button>
            </div>
            <div class="customerManage-table-div">
                <el-table class="table-class" tooltip-effect="dark" @sort-change="tableSort" :data="table.tableData" style="width: 100%;" border header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
                    <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
                    <el-table-column prop="id" label="客户ID" ></el-table-column>
                    <el-table-column prop="api_key" label="商户号" width="180px"></el-table-column>
                    <el-table-column prop="api_secret" label="商户密钥" width="250px" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="fs12 flexX flexcenter gap8">
                                <span>{{scope.row.api_secret}}</span>
                                <el-button v-if="scope.row.api_secret" type="text" @click="copy(scope.row.api_secret)"><i class="el-icon-copy-document" style="font-size: 12px;"></i></el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="aes_secret" label="AES密钥" width="250px" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="fs12 flexX flexcenter gap8">
                                <span>{{scope.row.aes_secret}}</span>
                                <el-button v-if="scope.row.aes_secret" type="text" @click="copy(scope.row.aes_secret)"><i class="el-icon-copy-document" style="font-size: 12px;"></i></el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="CK失效">
                        <template slot-scope="scope">
                            <div>
                                <div>总数：{{ scope.row.ck_total }}</div>
                                <div :class="{cdanger:scope.row.ck_invalid_count > 0}">失效：{{ scope.row.ck_invalid_count }}</div>                                
                            </div>
                            <!-- <el-tag size="small" :type="scope.row.ck_valid == 1 ? 'success' : 'danger'">{{scope.row.ck_valid_text}}</el-tag> -->
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="CK启用">
                        <template slot-scope="scope">
                            <div>
                                <div>总数：{{ scope.row.ck_total }}</div>
                                <div :class="{cdanger:scope.row.ck_disabled_count > 0}">停用：{{ scope.row.ck_disabled_count }}</div>
                            </div>
                            
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="客户信息" width="160px">
                        <template slot-scope="scope">
                            <div class="c303133">{{scope.row.name}}</div>
                            <div class="c606266 fs12">{{ scope.row.username }}</div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="name" label="客户昵称" ></el-table-column>
                    <el-table-column prop="username" label="客户邮箱"></el-table-column> -->
                    <el-table-column prop="money" label="余额" sortable = 'custom'>
                        <template slot-scope="scope">
                            <div class="cprimary fw5">¥{{scope.row.money}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="状态">
                        <template slot-scope="scope">
                            <el-tag size="small" type="success" v-if="scope.row.status == 1">启用</el-tag>
                            <el-tag size="small" type="danger" v-if="scope.row.status == 0">禁用</el-tag>
                        </template>
                    </el-table-column>
                   
                    <!-- <el-table-column prop="" label="商户后台">
                        <template slot-scope="scope">
                            <el-button type="text"><i class="el-icon-paperclip" ></i>进入后台</el-button>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="create_time" sortable = 'custom' label="注册时间" width="180px"></el-table-column>
                    <el-table-column label="操作"  fixed="right">
                        <template slot-scope="scope">

                            <el-dropdown @command="handleCommand($event,scope.row)" trigger="click">
                                <span class="el-dropdown-link">
                                    操作<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="editCustomer"><i class="el-icon-edit-outline"></i>编辑</el-dropdown-item>
                                    <el-dropdown-item command="balanceAction"><i class="el-icon-edit-outline"></i>余额操作</el-dropdown-item>
                                    <el-dropdown-item command="getBalanceDetail"><i class="el-icon-money"></i>余额详情</el-dropdown-item>
                                    <el-dropdown-item command="productConfig"><i class="el-icon-setting"></i>产品配置</el-dropdown-item>
                                    <el-dropdown-item command="CKConfig"><i class="el-icon-setting"></i>CK配置</el-dropdown-item>
                                    <el-dropdown-item command="resetPwd"><i class="el-icon-refresh"></i>重置密钥</el-dropdown-item>
                                    <el-dropdown-item command="deleteCustomer"><i class="el-icon-delete"></i><span class="cerror">删除</span></el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>


                            <!-- <el-link type="primary" @click="getBalanceDetail(scope.row)">余额详情</el-link>
                            <el-link class="table-operation" type="primary" @click="editCustomer(scope.row)">编辑</el-link>
                            <el-link type="danger" @click="deleteCustomer(scope.row)">删除</el-link> -->
                        </template>
                    </el-table-column>
                </el-table>
                <div class="flexX  pageBox flexEnd">
                    <el-pagination :disabled="loading"  @size-change="handleSizeChange"
                        @current-change="handleCurrentChange" :current-page="query.page" :page-sizes="query.pageSizesArr"
                        :page-size="query.pageSize" layout="total, sizes, prev, pager, next" :total="query.total"></el-pagination>
                </div>
            </div>
        </el-card>  
        <div class="dialog-div">
            <!-- 新增 -->
           <CustomerEdit v-if="dialog.add.visible"
                type="new" 
                :dialogVisible="dialog.add.visible" 
                :top="dialog.top" 
                :title="dialog.add.title" 
                :form="dialog.add.form" 
                @close="closeAdd" 
                @sure="addTrader" 
                :loading="dialog.add.loading">
            </CustomerEdit>
           <!-- 编辑 -->
            <CustomerEdit v-if="dialog.visible" 
                type="edit" 
                :dialogVisible="dialog.visible" 
                :top="dialog.top" 
                :title="dialog.title" 
                :form="dialog.form" 
                @close="close" 
                @sure="editTrader" 
                :loading="dialog.editLoading">
            </CustomerEdit>
           
            <BalanceDetail v-if="balanceDetail.visible" @closeBalanceDetail = "closeBalanceDetail" :balanceDetail="balanceDetail" :traderId="dialog.form.id" :dialogVisible="balanceDetail.visible"></BalanceDetail>
            <BalanceAction v-if="dialog.editBalance.visible" 
                :dialogVisible="dialog.editBalance.visible" 
                :editBalance="dialog.editBalance.form"
                @closeEditBalance="closeEditBalance"
                @editBalanceSure="setAmount"
                :loading="dialog.editBalance.loading">
            </BalanceAction>
            <ProductConfig v-if="productConfigData.visible" :drawer="productConfigData.visible" :customBathInfo="productConfigData.from" :loading="productConfigData.loading" @closeDrawer="closeDrawer" @saveConfig = 'saveConfig'></ProductConfig>
            <CKConfig v-if="CKConfigData.visible" ref="CKConfig" :dialogVisible="CKConfigData.visible" :loading = "CKConfigData.loading" title="CK配置" :form="CKConfigData.from" @sure = "CKsure" @close="closeCKConfig"></CKConfig>
        </div>
        
    </div>

   
</template>
<script>
    import CustomerEdit from '@/components/customerManage/customerEdit.vue'
    import BalanceDetail from '@/components/customerManage/balanceDetail.vue'
    import BalanceAction from '@/components/customerManage/balanceAction.vue'
    import ProductConfig from '@/components/customerManage/productConfig.vue'
    import CKConfig from '@/components/customerManage/CKConfig.vue'

	import {
		Message
	} from 'element-ui'
    export default {
        name: 'dashboard',
        components: { CustomerEdit,BalanceDetail,BalanceAction ,ProductConfig,CKConfig},
        data() {
			return {
                loading:false,
				query:{
                    traderId:'',
                    name:'',
                    email:'',
                    api_key:'',
                    create_time:[],
                    status:'',
                    page:1,
                    pageSizesArr:[10,50,200,500],
                    total:0,
                    pageSize: 10,
                    sortOrder:'',
                    sortField:'',
                    ck_valid:'',
                    ck_status:'',


                },
                table:{
                    tableData:[],
                    height:'200px',
                    // multipleSelection:[],
                  
                },
                dialog:{
                    //新增 编辑弹窗
                    top:"15vh",
                    visible:false,
                    title:'新增客户',
                    type:'new',
                    form:{
                        id:'',
                        nickname:'',
                        email:'',
                        balance:'',
                        
                    },
                    editLoading:false,
                    add:{
                        visible:false,
                        title:'新增客户',
                        form:{
                            id:'',
                            nickname:'',
                            email:'',
                            balance:'',
                        },
                        loading:false,
                    },
                    //余额弹窗
                    editBalance:{
                        form:{},
                        loading:false,
                        visible:false,
                    },
                    
                  
                }, 
                balanceDetail:{
                    visible:false,
                },
                productConfigData:{
                    visible: false,
                    from:{},
                    loading:false,
                },
                CKConfigData:{
                    visible: false,
                    from:{},
                    loading:false,
                },

            };
        },
        created() {
            this.query.create_time = [];
            this.getBalanceDetailHeight()
            this.memberTrader() 
        },
       
        methods: {
            //计算余额弹窗内表格高度
            getBalanceDetailHeight(){
                this.$nextTick(() => {			
                    let documentHeight = document.documentElement.clientHeight
                    this.dialog.editBalance.height =( documentHeight / 2) 
                })
            },
            ////计算窗口位置
            getDialogTop(className){
                // this.$nextTick(() => {			
                //     let documentHeight = document.documentElement.clientHeight
                //     let dialogdiv =  document.getElementsByClassName(className)[0].offsetHeight
                //     this.dialog.top =( documentHeight - dialogdiv) / 2 +'px'
                // })
            },
            // 计算表格高度
            getTableHeight(){
                this.$nextTick(() => {
                    let topNav = document.getElementsByClassName('topNav')[0].offsetHeight;
                    let queryBox = document.getElementsByClassName('customerManage-query')[0].offsetHeight;
                    let queryBtn = document.getElementsByClassName('customerManage-btn-div')[0].offsetHeight;
                    let pageBox = document.getElementsByClassName('pageBox')[0].offsetHeight;
                    let documentHeight = document.documentElement.clientHeight
                    this.table.height = documentHeight - topNav - queryBox -  queryBtn - pageBox - 40 - 40 - 40 - 31 - 20 - 10 +'px'
                })
            },
            //查询数据按钮
            getData(){
                this.query.page = 1
                this.query.total = 0
                this.memberTrader();
            },
            //列表查询
            memberTrader(){
                this.getTableHeight()
                console.log(this.query.sortOrder,'this.query.sortOrder,')
                let data = {
                    traderId: this.query.traderId.trim(),
                    name: this.query.name.trim(), 
                    email: this.query.email.trim(),
                    size: this.query.pageSize,
                    page: this.query.page,
                    sortField:this.query.sortField?this.query.sortField : null,
                    sortOrder:this.query.sortOrder?this.query.sortOrder : null,
                    api_key:this.query.api_key,
                    startTime: this.query.create_time.length == 2 ? this.$util.timestampToTime(Date.parse(new Date(this.query.create_time[0])), true) : '', // 下开始时间
                    endTime:this.query.create_time.length == 2 ? this.$util.timestampToTime(Date.parse(new Date(this.query.create_time[1])), true) : '', // 结束时间
                    status:this.query.status,
                    ck_valid: this.query.ck_valid,
                    ck_status: this.query.ck_status,
                }
                this.loading = true;
                this.$api.memberTrader(data).then(res => {
                    this.loading = false;
                    if(res.status == 1){
                        this.query.total = res.data.total;
                        this.table.tableData = res.data.data
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(err => {
                    this.loading = false;
                    console.log(err)
                })

            },
            //重置查询时间
            reset(){
                this.query.traderId='';
                this.query.name='';
                this.query.email='';
                this.query.total = 0
                this.query.page = 1
                this.query.api_key=''
                this.query.status=''           
                this.query.sortOrder=''
                this.query.sortField=''
                this.query.create_time = [];
                this.memberTrader();
            },
            // 分页查询数据
            handleSizeChange(val){
                this.query.pageSize = val;
                this.query.page = 1
                this.query.total = 0
                this.memberTrader()
            },
            handleCurrentChange(val){
                this.query.page = val
                this.memberTrader()
            },
            //新增客户
            addCustomer(){
                this.dialog.add.visible = true
                //计算窗口位置
                setTimeout(()=>{                    
                    this.getDialogTop(this.$refs.customerAdd)
                },100)
            },
            //编辑客户
            editCustomer(item){
                this.dialog.visible = true
                this.dialog.title = '编辑客户信息'
                this.dialog.type='edit'
                item.statusBoolean = item.status == 0 ? false : true
                this.dialog.form={...item}
                this.dialog.form.id=item.id
                this.dialog.form.nickname=item.name
                this.dialog.form.email = item.username
                this.dialog.form.balance = item.money
                //计算窗口位置
                this.getDialogTop('new-dialog-class')
            },
          
            //关闭弹窗
            close(){
                // this.resetForm('form')
                this.dialog.visible = false
                this.dialog.form.id=''
                this.dialog.form.nickname = ''
                this.dialog.form.email = ''
                this.dialog.form.balance = ''
                this.dialog.editLoading = false
            },
            closeAdd(){
                this.dialog.add.visible = false
                this.dialog.add.form.id=''
                this.dialog.add.form.nickname = ''
                this.dialog.add.form.email = ''
                this.dialog.add.form.balance = ''
                this.dialog.add.loading = false
            },
            //新增客户、编辑客户 确定
            // sure(){
            //     this.$refs['form'].validate((valid) => {
            //         if (valid) {
            //             //新增客户
            //             if(this.dialog.type =='new'){
                            
            //                 this.addTrader()
            //             }else{//编辑客户
            //                 this.editTrader()
            //             }
                       
            //         } else {
            //             return false;
            //         }
            //     });              
            // },
            //新增客户
            addTrader(form){
                let data = {
                    "name": form.nickname, // 客户昵称
                    "email": form.email, //  邮箱
                    "money": form.balance?form.balance:0,// 余额 
                    "status":1
                }
                this.dialog.add.loading = true;
                this.$api.addTrader(data).then(res=>{
                    this.dialog.add.loading = false;
                    if(res.status == 1){
                        // this.close()
                        this.dialog.add.visible = false
                        this.getData();
                        Message({
                            message: res.msg,
                            type: 'success',
                            duration: 3 * 1000
                        });
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(error=>{
                    this.dialog.add.loading = false;
                })

            },
            //编辑客户
            editTrader(form){
                let data ={
                    "traderId": form.id,
                    "name":  form.nickname, // 客户昵称
                    "email":  form.email, //  邮箱
                    "status": form.status,
                }
                this.dialog.editLoading = true;
                this.$api.editTrader(data).then(res=>{
                    this.dialog.editLoading = false;
                    if(res.status == 1){
                        this.dialog.visible = false
                        this.memberTrader()
                        Message({
                            message: res.msg,
                            type: 'success',
                            duration: 3 * 1000
                        });
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }

                }).catch(error=>{
                    this.dialog.editLoading = false;
                })
            },
            // 余额详情
            getBalanceDetail(item){
                this.getBalanceDetailHeight()
                this.dialog.form.id=item.id
                this.balanceDetail.visible = true
            },
            
            //列表选中事件
            // handleSelectionChange(val){
            //     this.table.multipleSelection = val;
            //     console.log(this.table.multipleSelection)
            // },
            //表格排序
            tableSort(column){
                // id|money|create_time 
                //  asc  desc

                this.query.sortField = column.prop
                this.query.sortOrder = (column.order?(column.order == "ascending"?"asc" : "desc"):'')
                this.getData()
            },
            //关闭余额详情弹窗
            closeBalanceDetail(){
                this.balanceDetail.visible = false                
                this.dialog.form.id=''
            },
            //删除客户
            deleteCustomer(item){
                if(Number(item.money) > 0){
                    this.$confirm("请清空该客户余额后重试！", '无法删除！', {
                            distinguishCancelAndClose: true,
                            confirmButtonText: '确定',
                            cancelButtonText: '取消'
                        }).then(()=>{

                        }).catch(() => {
                        })
                }else{
                    this.$confirm(`确定要删除客户 ${item.name} 吗？`, '删除确认', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                    .then(() => {
                        this.deleteTrader(item.id)
                        //删除失败弹窗                    
                    
                    })
                    .catch(action => {
                    
                    });
                }
                
            },
            //删除客户接口
            deleteTrader(id){
                let data = {
                    "traderId": id // 客户id
                }
                this.loading = true;
                this.$api.deleteTraderCompletely(data).then(res=>{
                    this.loading = false;
                    if(res.status == 1){
                        Message({
                            message: res.msg,
                            type: 'success',
                            duration: 3 * 1000
                        });
                        this.getData()
                    }else{
                        Message({
                            message:res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        })
                    }
                    
                }).catch(e=>{
                    this.loading = false;
                })
            },
            //编辑余额弹窗打开
            openEditBalance(row){
                this.dialog.editBalance.visible = true
                this.dialog.editBalance.form = {...row}
                // this.getDialogTop('inner-dialog-class')
            },
            //编辑余额弹窗关闭
            closeEditBalance(){
                this.dialog.editBalance.visible = false
                this.dialog.editBalance.balance =""
                this.dialog.editBalance.balanceType = 'IN'     
            },
            //余额调整接口
            setAmount(form){
                let data = {
                    "traderId":  form.id,
                    "type": form.balanceType, // 增减类型
                    "amount": form.balance, //  金额
                    "note": form.note
                }
                this.dialog.editBalance.loading = true
                this.$forceUpdate()
                this.$api.setAmount(data).then(res=>{
                    this.dialog.editBalance.loading = false
                    if(res.status == 1){
                        this.memberTrader()
                        //调整余额成功后将修改后余额赋给当前余额
                        this.dialog.form.balance = this.dialog.editBalance.nowBalance;
                        this.closeEditBalance()
                        Message({
                            message: res.msg,
                            type: 'success',
                            duration: 3 * 1000
                        });
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        })
                    }
                }).catch(e=>{
                    this.dialog.editBalance.loading = false
                })
            },
            //余额操作
            balanceAction(row){
                this.openEditBalance(row)
            },
            productConfig(row){
                this.productConfigData.visible = true
                this.productConfigData.from = {...row}
            },
            closeDrawer(){
                this.productConfigData.visible = false
                this.productConfigData.from = {}

            },
            //重置密钥
            resetPwd(item){
                this.$confirm(`确认重置客户 " ${item.name}" 的商户密钥和AES密钥吗？重置后原密钥将失效。`, '重置密钥确认', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    this.resetTraderPwd(item.id)
                    //删除失败弹窗                    
                
                })
                .catch(action => {
                
                });
            },
            //重置密钥接口
            resetTraderPwd(traderId){
                this.$api.resetTraderSecrets({traderId:traderId}).then(res=>{ 
                    if(res.status == 1){ 
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })
                        
                        this.memberTrader();
                    }else{ 
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        })
                    }
                })
            },
            //操作
            handleCommand(command, row){                
                this[command](row);            
            },
            //保存配置
            saveConfig(data){
                this.productConfigData.loading = true
                this.$api.saveConfig(data).then(res => {
                    this.productConfigData.loading = false
                    if(res.status == 1){
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })
                        this.closeDrawer()

                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        })
                    }
                    
                }).catch(e=>{
                    this.productConfigData.loading = false
                })
            },
            copy(textCopy){
                const contentToCopy = textCopy
				// 创建一个临时的 textAREA 元素
				const textarea = document.createElement('textarea')
				textarea.value = contentToCopy
				document.body.appendChild(textarea)
				textarea.select()
				document.execCommand('copy')
				document.body.removeChild(textarea)
				this.$message({
					type: 'success',
					message: '已复制到剪切板'
				})
            },
            //CK配置
            CKConfig(row){
                this.CKConfigData.visible = true
                this.CKConfigData.from = {...row}
            },
            closeCKConfig(){
                this.CKConfigData.visible = false
                this.CKConfigData.from = {}
            },
            CKsure(param){
                // console.log(param,'ck param')              
               
                if(param.id){
                    
                    this.updateCkConfig(param)
                }else{
                    this.addCkConfig(param)
                }
             
            },
            //更新ck配置接口
            updateCkConfig(param){
                let data ={
                    ck_id:param.id,
                    ck_name:param.ck_name,
                    ck_value:param.ck_value,
                    ck_status:param.ck_status,
                    sort_order:param.sort_order,
                } 
                this.CKConfigData.loading = true
                this.$api.updateCkConfig(data).then(res=>{  
                    this.CKConfigData.loading = false
                    if(res.status == 1){
                        this.$message.success(res.msg)
                        this.memberTrader();
                        this.$refs.CKConfig.getCkConfig()
                    }else{
                        this.$message.error(res.msg)
                    }
                }).catch(e=>{
                    this.CKConfigData.loading = false
                })
                
            },
            //添加ck配置接口
            addCkConfig(param){
                
                this.CKConfigData.loading = true
                this.$api.addCkConfig(param).then(res=>{
                    this.CKConfigData.loading = false
                    if(res.status == 1){
                        this.$message.success(res.msg)
                        this.memberTrader();
                        this.$refs.CKConfig.getCkConfig()
                        // this.closeCKConfig()
                    }else{
                        this.$message.error(res.msg)
                    }
                }).catch(e=>{
                    this.CKConfigData.loading = false;
                })
            }
        }
    }
</script>
<style lang="scss">
    @import "@/style/tablestyle.scss";
    // .customerManage-container{
    //     .dialog-div{
    //         .el-form-item__label{
    //             width: 100px !important;
    //         }
    //     }
    // }
	// @import '@/style/variables.scss';
</style>
<style lang="scss" scoped>
//内层弹窗input框样式
    .customerManage-container{
        // padding-top: 10px;
        // padding-right: 20px;
        .customerManage-query{
            // padding-left:34px;
            display:flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items:flex-start;

            .customerManage-query-input{
                display:flex;
                flex-wrap: wrap;
                .query-input-item{
                    margin-right:25px;
                    margin-bottom: 16px;
                    display:flex;
                    font-size:14px;
                    align-items:center;
                    .input-item-label{
                        white-space: nowrap;
                        margin-right: 10px;
                        color:#606266;
                    }
                    .query-input{
                        width: 180px;
                        margin-left: 20px;
                    }
                    .query-select{
                        width: 140px;
                    }
                    .query-date{
                        width: 240px;
                    }
                    
                }
                &.query-input-flex-between{
                    justify-content: space-between;
                    width: 100%;
                }
            }
            .customerManage-query-btn{
                margin-left: 7px;
                .query-btn{
                    width: 80px;
                    height: 30px;
                }
                .cancel{
                    margin-left: 14px;
                }
            }
        }          
        .customerManage-btn-div{            
            // padding-left:34px;
            background: #fafcff;
            display: flex;
            align-items: center;
            padding: 16px 20px;
            border-bottom: solid 1px #ebeef5;
            .add-btn{
                width: 80px;
                height: 30px;
                // margin-top:31px;
            }
        }
        .customerManage-table-div{
            margin-top: 31px;
            // margin-left:34px;
            .table-operation{
                margin: 0 24px;
            }
           .pageBox{
            padding: 16px 20px;
            border-top: 1px solid #ebeef5;
            background-color: #fafcff;
            // position:absolute;  
            // bottom: 50PX;
            // right: 30px;

           }
           .table-class{
            .el-dropdown-link {
                cursor: pointer;
                color: #409EFF;
            }
            .el-icon-arrow-down {
                font-size: 12px;
            }
           }
        }
       
        
    }
</style>